<template>
  <div class="users-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t('user.macAddress') }}</span>
        <list-search
          @listSearchEvn="listSearchEvn"
          @clearSearch="listSearchEvn"
        />
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'importFacilitys' })"
        >
          {{ $t('commonMsg.add') }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="">
        <div class="global-table-header">
          <div class="facilitys-table-header-left">
            <p>设备总数量：{{ total ? total : 0 }}</p>
            <p>未锁定数量：{{ unlockCount ? unlockCount : 0 }}</p>
            <p>锁定数量：{{ lockCount ? lockCount : 0 }}</p>
            <p>正在锁定数量：{{ lockIngCount ? lockIngCount : 0 }}</p>
          </div>
          <div v-if="selectData.length">
            <button class="global-button-style" @click="batchLock">
              {{ $t('user.lock') }}
            </button>
            <button class="global-button-style" @click="batchUnLock">
              {{ $t('user.unlock') }}
            </button>
            <button class="global-button-style" @click="batchUnBind">
              {{ $t('user.unbind') }}
            </button>
            <button class="global-button-style" @click="batchResetPsw">
              {{ $t('user.resetPsw') }}
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <FacilityTable
          :tableProps="tableProps"
          :tableData="tableData"
          :selectCtrl="true"
          @tableHandle="tableHandle"
          @tableSelectionChange="tableSelectionChange"
          @tableFilterChange="tableFilterChange"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>

    <el-dialog
      title="操作记录"
      :visible.sync="showRecord"
      @closed="closeRecordDialog"
      width="900px"
      custom-class="user-facilitys-dialog"
      center
    >
      <div class="user-facilitys-header">
        <TabHeader
          :slideData="slideData"
          :tab="recordTab"
          @headerTabBack="headerTabBack"
        />
        <!-- <div class="user-facilitys-header-right">
          <List-search
            ref="recordSearch"
            @listSearchEvn="recordSearchEvn"
            @clearSearch="clearRecordSearch"
          />
          <button class="global-button-style" @click="getRecord">更新</button>
        </div> -->
      </div>
      <div class="user-facilitys-line"></div>
      <div class="user-facilitys-main app-table-container">
        <div class="global-body-wrap">
          <template v-if="recordTab === 'deviceBinding'">
            <RecordTableData
              key="deviceBinding"
              :tableProp="recordProps"
              :tableData="recordData"
              :currentPage="recordPage"
              :pageSize="recordParams.limit"
            />
            <Pagination
              :pageSize="recordParams.limit"
              :total="recordCount"
              :currentPage="recordPage"
              @pageNum="recordPageNum"
            />
          </template>
          <template v-else-if="recordTab === 'deviceHandle'">
            <RecordTableData
              key="deviceHandle"
              :tableProp="historyProps"
              :tableData="historyData"
              :currentPage="historyParams.page"
              :pageSize="historyParams.limit"
              :handleBtn="historyHandleBtn"
              @tableHandle="historyTableHandle"
            />
            <Pagination
              :pageSize="historyParams.limit"
              :total="historyCount"
              :currentPage="historyParams.page"
              @pageNum="historyPageNum"
            />
          </template>
          <template v-else-if="recordTab === 'deviceLogin'">
            <RecordTableData
              key="deviceLogin"
              :tableProp="loginProps"
              :tableData="loginData"
              :currentPage="loginParams.page"
              :pageSize="loginParams.limit"
            />
            <Pagination
              :pageSize="loginParams.limit"
              :total="loginCount"
              :currentPage="loginParams.page"
              @pageNum="loginPageNum"
            />
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TabHeader from '@/components/tabHeader'
import FacilityTable from '@/components/facilityTable'
import RecordTableData from '@/components/tableView'
import Pagination from '@/components/pagination'
import ListSearch from '@/components/listSearch'

export default {
  components: {
    TabHeader,
    FacilityTable,
    RecordTableData,
    Pagination,
    ListSearch
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: '绑定记录',
          component: 'deviceBinding'
        },
        {
          name: '设备操作记录',
          component: 'deviceHandle'
        },
        {
          name: '登入/登出操作记录',
          component: 'deviceLogin'
        }
      ]
      return slideData
    },
    tableProps() {
      let tableProps = [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'users',
          label: this.$t('user.nickname')
        },
        {
          prop: 'lock',
          label: this.$t('user.lockStatus')
        },
        {
          prop: 'model',
          label: this.$t('user.model')
        },
        {
          prop: 'buildId',
          label: '设备版本'
        },
        {
          prop: 'macAddress',
          label: this.$t('user.macAddress')
        },
        {
          prop: 'handle',
          label: this.$t('org.manage'),
          width: 240,
          btn: ['操作记录', this.$t('user.unbind'), this.$t('user.resetPsw')]
        }
      ]
      return tableProps
    },
    recordProps() {
      let recordProps = [
        {
          prop: 'user_id',
          label: this.$t('user.id')
        },
        {
          prop: 'user.name',
          label: this.$t('user.username'),
          obj: true
        },
        {
          prop: 'user.nickname',
          label: this.$t('user.nickname'),
          obj: true
        },
        {
          prop: 'user.phone',
          label: this.$t('user.phone'),
          obj: true
        },
        {
          prop: 'user.email',
          label: this.$t('user.email'),
          obj: true
        },
        {
          prop: 'updated_at',
          label: '绑定时间'
        }
      ]
      return recordProps
    },
    historyProps() {
      let historyProps = [
        {
          prop: 'userId',
          label: '用户ID'
        },
        {
          prop: 'deviceId',
          label: '设备ID'
        },
        {
          prop: 'mac',
          label: this.$t('user.macAddress')
        },
        {
          prop: 'actionType',
          label: '操作类型'
        },
        {
          prop: 'updatedAt',
          label: '时间'
        }
      ]
      return historyProps
    },
    historyHandleBtn() {
      return [{ style: 'checkDetailsBtn', type: 'recall', title: '撤回' }]
    },
    loginProps() {
      let loginProps = [
        {
          prop: 'mac',
          label: 'MAC'
        },
        {
          prop: 'loginType',
          label: '登录类型'
        },
        {
          prop: 'loginStatus',
          label: '登录状态'
        },
        {
          prop: 'latestLoginTime',
          label: '最后登入时间'
        },
        {
          prop: 'latestLogoutTime',
          label: '最后登出时间'
        }
      ]
      return loginProps
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      paramsList: { limit: 20, offset: 0, sortBy: 'lock', orderBy: 'DESC' },
      selectData: [],
      lockCount: 0,
      lockIngCount: 0,
      unlockCount: 0,
      showRecord: false,
      currentItem: null,
      recordParams: {
        limit: 20,
        offset: 0,
        sortBy: 'updated_at',
        orderBy: 'DESC'
      },
      historyParams: {
        limit: 20,
        page: 1,
        sortBy: 'updated_at',
        orderBy: 'DESC'
      },
      loginParams: {
        limit: 20,
        page: 1,
        sortBy: 'updated_at'
      },
      historyData: [],
      historyCount: 0,
      loginData: [],
      loginCount: 0,
      recordData: [],
      recordCount: 0,
      recordPage: 1,
      recordTab: 'deviceBinding'
    }
  },
  methods: {
    async getfacilitys() {
      let res = await this.$http.getfacilitys(this.paramsList)
      this.selectData = []
      this.total = res.data.count
      this.tableData = res.data.rows
      this.lockCount = res.data.lockCount
      this.lockIngCount = res.data.lockIngCount
      this.unlockCount = res.data.unlockCount
    },

    async facilityUntie(item) {
      const data = {
        deviceUniqueId: item.deviceUniqueId,
        mac: item.macAddress
      }
      await this.$http.facilityUntie(data)
      this.getfacilitys()
      this.elMsg(this.$t('alertMsg.unlockSuccess'), 'success')
    },

    listSearchEvn(val) {
      val
        ? (this.paramsList.macAddress = val)
        : delete this.paramsList.macAddress
      this.paramsList.offset = 0
      this.getfacilitys()
    },

    tableHandle(obj) {
      this.currentItem = obj.data.row
      if (obj.type == this.$t('user.unbind')) {
        this.facilityUntie(obj.data.row)
      } else if (obj.type == this.$t('user.lock')) {
        this.facilityLock('lock', obj.data.row.id)
      } else if (obj.type == this.$t('user.unlock')) {
        this.facilityLock('unlock', obj.data.row.id)
      } else if (obj.type == this.$t('user.resetPsw')) {
        this.resetMacPwd(obj.data)
      } else if (obj.type == '操作记录') {
        this.headerTabBack()
      }
    },

    headerTabBack(tab = null) {
      if (tab) {
        if (this.recordTab === tab.component) return
        this.recordTab = tab.component
      }
      if (this.recordTab === 'deviceBinding') {
        this.recordParams.mac = this.currentItem.macAddress
        this.getbindingRecord()
      } else if (this.recordTab === 'deviceHandle') {
        this.historyParams.deviceId = this.currentItem.id
        this.getDevicesHistory()
      } else if (this.recordTab === 'deviceLogin') {
        this.loginParams.mac = this.currentItem.macAddress
        this.getDevicesLogin()
      }
    },

    async getDevicesLogin() {
      let res = await this.$http.getDevicesLogin(this.loginParams)
      this.loginData = res.data.results
      this.loginCount = res.data.count
      this.showRecord = true
    },

    loginPageNum(val) {
      this.loginParams.page = val
      this.getDevicesLogin()
    },

    async getDevicesHistory() {
      let res = await this.$http.getDevicesHistory(this.historyParams)
      this.historyData = res.data.results
      this.historyCount = res.data.count
      this.showRecord = true
    },

    historyPageNum(val) {
      this.historyParams.page = val
      this.getDevicesHistory()
    },

    historyTableHandle({ type, data }) {
      if (type === 'recall') {
        this.recallHistory(data)
      }
    },

    async recallHistory(data) {
      await this.$http.recallDevices({ _id: data._id })
      this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
    },

    async getbindingRecord() {
      let res = await this.$http.getbindingRecord(this.recordParams)
      this.recordData = res.data.rows
      this.recordCount = res.data.count
      this.showRecord = true
    },

    recordPageNum(val) {
      this.recordPage = val
      this.recordParams.offset = (val - 1) * this.recordParams.limit
      this.getbindingRecord()
    },

    closeRecordDialog() {
      this.recordTab = 'deviceBinding'
      this.recordPage = 1
      this.recordParams = {
        limit: 20,
        offset: 0,
        sortBy: 'updated_at',
        orderBy: 'DESC'
      }

      this.historyParams = {
        limit: 20,
        page: 1,
        sortBy: 'updated_at',
        orderBy: 'DESC'
      }
    },

    async resetMacPwd(data) {
      try {
        await this.$http.resetMacPwd({
          id: data.row.id,
          deviceUniqueId: data.row.deviceUniqueId,
          mac: data.row.macAddress
        })
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (err) {
        this.elMsg(err.response.data.message, 'error')
      }
    },

    async facilityLock(type, id) {
      try {
        await this.$http.facilityLock({ type, id })
        this.getfacilitys()
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (err) {
        this.elMsg(err.response.data.message, 'error')
      }
    },

    pageNum(val) {
      this.paramsList.offset = (val - 1) * this.paramsList.limit
      this.getfacilitys()
    },

    tableSelectionChange(data) {
      this.selectData = data
    },

    tableFilterChange(data) {
      let arr = Object.values(data)[0]
      if (arr.length) {
        this.paramsList.lock = { $in: arr }
      } else {
        delete this.paramsList.lock
      }
      this.paramsList.offset = 0
      this.getfacilitys()
    },

    batchLock() {
      let ids = this.selectData.map((item) => item.id)
      this.facilityBatchLock('lock', ids)
    },
    batchUnLock() {
      let ids = this.selectData.map((item) => item.id)
      this.facilityBatchLock('unlock', ids)
    },
    batchUnBind() {
      let ids = this.selectData.map((item) => item.id)
      this.facilityBatchUntie(ids)
    },
    batchResetPsw() {
      let ids = this.selectData.map((item) => item.id)
      this.batchResetMacPwd(ids)
    },

    async facilityBatchLock(type, id) {
      try {
        await this.$http.facilityLock({ type, id })
        this.getfacilitys()
        this.selectData = []
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (error) {
        this.elMsg(error.response.data.message, 'error')
      }
    },
    async facilityBatchUntie(ids) {
      try {
        await this.$http.facilityBatchUntie({ ids })
        this.getfacilitys()
        this.selectData = []
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (error) {
        this.elMsg(error.response.data.message, 'error')
      }
    },

    async batchResetMacPwd(id) {
      try {
        await this.$http.resetMacPwd({ id })
        this.getfacilitys()
        this.selectData = []
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (error) {
        this.elMsg(error.response.data.message, 'error')
      }
    }
  },
  mounted() {
    this.getfacilitys()
  }
}
</script>

<style lang="scss">
.users-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .right-part {
    display: flex;
    align-items: center;
  }
  .facilitys-table-header-left {
    display: flex;
    align-content: center;
    > p {
      margin-right: 20px;
    }
  }
}
.user-facilitys-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 10px; */
  .user-facilitys-header-right {
    display: flex;
    align-items: center;
    > button {
      margin-top: 0;
      margin-left: 20px;
    }
  }
}
.user-facilitys-dialog {
  > .el-dialog__body {
    padding: 0;
    > .app-table-container {
      margin: 0;
    }
  }
  .user-facilitys-line {
    height: 20px;
    background: $mainBGColor;
  }
  .user-facilitys-main {
    box-sizing: border-box;
    height: 600px;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
